import { render, staticRenderFns } from "./input_copy.vue?vue&type=template&id=3d263212&scoped=true&lang=pug&"
import script from "./input_copy.vue?vue&type=script&lang=js&"
export * from "./input_copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d263212",
  null
  
)

export default component.exports